import OngoingList from "./OngoingList";
import TaskWrapper from "../TaskWrapper";

export default function Ongoing({ list }) {
  return (
    <TaskWrapper title="ONGOING" status="ongoing" total={list?.length}>
      <OngoingList list={list} />
    </TaskWrapper>
  );
}
